import { render } from "./ReStart.vue?vue&type=template&id=1195c2bc&scoped=true&ts=true"
import script from "./ReStart.vue?vue&type=script&lang=ts"
export * from "./ReStart.vue?vue&type=script&lang=ts"

import "./ReStart.vue?vue&type=style&index=0&id=1195c2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1195c2bc"]])

export default __exports__